import { Button } from '@modusign/design-system';
import { useSelector } from 'react-redux';

import inPersonImage from '@app/assets/inperson-upselling.gif';
import {
  UpSellingModal,
  UpSellingModalContent,
  UpSellingModalFooter,
  UpSellingModalHeader,
  UpSellingModalTitle,
} from '@app/components/UpSellingModal';
import { getSubscriptionPlanGrade } from '@app/features/subscription/state';

interface InPersonSellingInfo {
  headLine: string;
  redirectUrl: string;
  redirectLabel: string;
}

interface InPersonUpSellingModalProps {
  isOpen: boolean;
  onCloseClicked: () => void;
}

export default function InPersonUpSellingModal({
  isOpen,
  onCloseClicked,
}: InPersonUpSellingModalProps) {
  const grade = useSelector(getSubscriptionPlanGrade);
  const getUpSellingInfos = (): InPersonSellingInfo => {
    switch (grade) {
      case 1:
      case 2:
        return {
          headLine: '신규 요금제로 변경 후 이용해 주세요.',
          redirectLabel: '요금제 상담',
          redirectUrl: '/payment/plan-change',
        };
      case -1:
        return {
          headLine: '문의를 통해 이용할 수 있습니다',
          redirectLabel: '문의하기',
          redirectUrl: 'https://share.hsforms.com/18LXRDT3GSTSbVjjPMELNBQc4eum',
        };
      default:
        return {
          headLine: '문의를 통해 이용할 수 있습니다',
          redirectLabel: '문의하기',
          redirectUrl: 'https://share.hsforms.com/1uDKiRg_LRjWzadCUl-PkAwc4eum',
        };
    }
  };

  const { headLine, redirectUrl, redirectLabel } = getUpSellingInfos();

  return (
    <UpSellingModal isOpen={isOpen} onRequestClose={onCloseClicked}>
      <UpSellingModalHeader>{headLine}</UpSellingModalHeader>
      <UpSellingModalTitle onCloseClicked={onCloseClicked}>대면서명</UpSellingModalTitle>
      <UpSellingModalContent
        description={
          <>
            이제 서명자와 같은 공간, 같은 기기에서 <br />
            바로 내용을 공유하며 서명을 받을 수 있습니다.
          </>
        }
        imageSrc={inPersonImage}
      />
      <UpSellingModalFooter>
        <Button
          mr={3}
          variant="basic"
          onClick={() => {
            window.open(
              'https://support.modusign.co.kr/98042074918',
              '_blank',
              'noopener,noreferrer'
            );
          }}
        >
          기능 안내
        </Button>
        <Button
          variant="primary"
          width="180px"
          onClick={() => {
            window.open(redirectUrl, '_blank', 'noopener,noreferrer');
          }}
        >
          {redirectLabel}
        </Button>
      </UpSellingModalFooter>
    </UpSellingModal>
  );
}
